import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { AsyncSubject, Observable } from "rxjs";
import { Transaction } from "../_types/transaction";
import { HttpClient } from "@angular/common/http";
import { LoaderService } from "src/app/core/loader/loader.service";
import { TemplatesService } from "../../templates/_services/templates.service";
import { File } from "../../common/_types/file";
import { saveAs } from 'file-saver';

@Injectable({
    providedIn: 'root',
})

export class TransactionsService extends Service<Transaction> {
  public override type = 'transactions';
  public override url = 'invoicing/transactions'; 

  constructor(
    _http: HttpClient,
    _loaderService: LoaderService,
    private templateService: TemplatesService
  ) {
    super(_http, _loaderService);
  }

  public downloadExcelTemplate() {
    let url = this.getAPIUrl() + '/excelTemplate';
    return this.http.get(url, { responseType: 'blob' }).subscribe((response: Blob) => {
      saveAs(response, 'plantilla-lineas.xlsx');
    });
  }

  public uploadExcel(id: string, file: any): Observable<any> {

    let subject = new AsyncSubject<any>();
    let data = new FormData();
    data.append('file', file);

    let url = this.getAPIUrl() + '/' + id + '/uploadExcel';

    this.http.put(url, data).subscribe({
      next: (response) => {
        subject.next(response);
        subject.complete();
      },
      error: (error) => {
        subject.error(error);
      }
    });
    return subject.asObservable();
  }

  public workerTransactionByJobs(workerId:string, data: any): Observable<void> {
    
    let url = this.getAPIUrl()+"/" + workerId + '/workerTransaction';        
    return this.http.post<void>(url, data);
  }

  public workerTransactionBusiness(workerId:string, data: any): Observable<void> {
    let url = this.getAPIUrl()+"/" + workerId + '/workerTransactionBusiness';        
    return this.http.post<void>(url, data);
  }
  
  public export(transactionId?: string, templateId?: string, metadata?:any) {
    let url = this.getAPIUrl()+"/" + transactionId + '/' + templateId + '/export/pdf';    
    this.templateService.open(url, metadata);
  }

  public exportTransaction(transactionId?: string, templateId?: string, metadata?: any) : Promise<Blob>{
    let url = this.getAPIUrl()+"/" + transactionId + '/' + templateId + '/export/pdf';    
    return new Promise(async resolve => {
        this.http.post(url, metadata, { responseType: 'blob' }).subscribe((response: Blob) => {
          resolve(response);
        });
      });
  }
  
  public exportXml(transactionId: string): Promise<Blob> {
    let url = this.getAPIUrl() + "/" + transactionId + '/xml';
    return new Promise((resolve, reject) => {
      this.http.get(url, { responseType: 'blob' }).subscribe({
        next: (response: Blob) => resolve(response),
        error: (error) => reject(error)
      });
    });
  }

  public generateTransactionSerie(transactionTypeId: string, companyId: string | null): Observable<any> {
    return this.http.get<any>(this.getAPIUrl()+"/"+transactionTypeId+"/generateTransactionSerie"+(companyId!=null?"/"+companyId:""));
  }
  

  public generateInvoice(thirdPartyId: string, data: any): Observable<void> {
    let url = this.getAPIUrl()+"/" + thirdPartyId + "/generateInvoice";        
    return this.http.post<void>(url, data);
  }

  public invoicePendingJobs(data: any): Observable<any> {
    let url = this.getAPIUrl()+"/invoicePendingJobs";
    return this.http.post<any>(url, data);
  }

  //registra el envío de la factura a la compañía a través de su integración
  public sendToCompany(transactionId: string): Observable<any> {
    let url = this.getAPIUrl()+"/" + transactionId + "/sendToCompany";
    return this.http.post<any>(url, {});
  }

  public generatePaymentReturn(data: any): Observable<void> {
    let url = this.getAPIUrl()+"/generatePaymentReturn";        
    return this.http.post<void>(url, data);
  }

  public generateWorkRetention(data: any): Observable<void> {
    let url = this.getAPIUrl()+"/generateWorkRetention";        
    return this.http.post<void>(url, data);
  }  

  public generateClientCompensation(data: any): Observable<void> {
    let url = this.getAPIUrl()+"/generateClientCompensation";        
    return this.http.post<void>(url, data);
  }

  public generateWorkerInvoiceRequest(data: any): Observable<void> {
    let url = this.getAPIUrl()+"/generateWorkerInvoiceRequest";        
    return this.http.post<void>(url, data);
  }  

  public generateReview(data: any): Observable<void> {
    let url = this.getAPIUrl()+"/generateReview";        
    return this.http.post<void>(url, data);
  }

  public deliveryNotesCsvCheck(file: any, companyId: string, contractId: string): Observable<any> {
    let url = this.getAPIUrl()+"/deliveryNotesCsvCheck";      
    url += `?companyId=${companyId}&contractId=${contractId}`;

    let subject = new AsyncSubject<any>()  
    
    const data: FormData = new FormData();
    data.append('file', file, file.fileName);
    this.http.post(url, data).subscribe((response: any) => {
      subject.next(response);
      subject.complete();
    });

    return subject.asObservable();
  }

  public deliveryNotesCsvProcess(file: any, companyId: string, contractId: string, code: string, date: Date, paymentMethodId: string, paymentDuedate: Date, billingCompanyBankAccountId?: string, transactionSerieId?: string): Observable<any> {
    let url = this.getAPIUrl()+"/deliveryNotesCsvProcess";
    url += `?companyId=${companyId}&contractId=${contractId}&code=${code}&date=${date.toISOString()}&paymentMethodId=${paymentMethodId}&paymentDuedate=${paymentDuedate.toISOString()}&billingCompanyBankAccountId=${billingCompanyBankAccountId ?? ''}&transactionSerieId=${transactionSerieId ?? ''}`;   

    let subject = new AsyncSubject<any>()  
    
    const data: FormData = new FormData();
    data.append('file', file, file.fileName);
    this.http.post(url, data).subscribe((response: any) => {
      subject.next(response);
      subject.complete();
    });

    return subject.asObservable();
  }

  public pay(id: string): void {
    let url = this.getAPIUrl()+"/" + id + '/pay';
    location.href = url;
  }

}
